import React from 'react';

import platformName from '../../utilities/get.platform.name';

export default () => (
  <header className="header">
    <span className="header__platform-name">{`${platformName} Taskpane`}</span>
  </header>
);
